import { AxiosResponse } from 'axios';

export const parseFileName = (response: AxiosResponse<any, any>) => {
    const headerLine = response?.headers['content-disposition']?.split('filename=')[1];
    let startFileNameIndex = headerLine.indexOf('"') + 1;
    let endFileNameIndex = headerLine.lastIndexOf('"');
    const fileName = headerLine.substring(startFileNameIndex, endFileNameIndex);
    const file = fileName.split('.');
    return file.length < 2 ? { fileName } : { fileName: file[0], type: `.${file[1]}` };
};

export const triggerBrowserDownload = (blob: Blob, nameOfDownloadedFile: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nameOfDownloadedFile);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

export const extractFileNameFromPreSigneUrl = (presignedUrl: string): string | undefined => {
    const match = presignedUrl.match(/\/([^/?]+)(?:\?|$)/); //  extracts the last path segment of a URL (i.e. the filename), stopping before the query string or end of the URL.
    return match ? decodeURIComponent(match[1]) : undefined;
};
